import React, { Fragment } from 'react';

import PageObjectTile from '@atlaskit/object/tile/page';
import WorkItemObjectTile from '@atlaskit/object/tile/work-item';
import { type QuickFindAllActivityDataEdge } from '@atlassian/dynamic-cards-search-client';

import { EventTypeMessage } from '../../../../common/ui/event-type-message';
import { type SearchLinkProps } from '../../../../common/ui/search-link';

import { ConfluenceResultMeta } from './confluence-result-meta';

const CONTEXT_PATH = '/wiki/spaces';

export const recentViewsResultMapper: (edge: QuickFindAllActivityDataEdge) => SearchLinkProps = (
	edge,
) => {
	const item = edge.node;
	const iconLabel = `${item.object.product} ${item.object.type}`;

	switch (item.object.product) {
		case 'jira':
			return {
				title:
					`${item.object.data?.key}: ${
						(item.object.data?.fieldsById?.edges || [{}])[0].node?.text
					}` || '',
				description: `Jira ${item.object.type}`,
				subheading: (
					<EventTypeMessage timestamp={item.event.timestamp} eventType={item.event.eventType} />
				),
				icon: <WorkItemObjectTile size="small" label={iconLabel} />,
				onClick: () => {},
				navigationUrl: item.object.data?.webUrl || '',
			};
		case 'confluence':
			return {
				title: item.object.data?.title || '',
				description: (
					<ConfluenceResultMeta
						resultContentType={item.object.type}
						resultAncestors={item.object.data?.ancestors}
						resultSpace={item.object.data?.space}
					/>
				),
				subheading: (
					<EventTypeMessage timestamp={item.event.timestamp} eventType={item.event.eventType} />
				),
				icon: <PageObjectTile size="small" label={iconLabel} />,
				onClick: () => {},
				navigationUrl: `${item.object.data?.links?.base || CONTEXT_PATH}${
					item.object.data?.links?.webUi || ''
				}`,
			};
		case 'townsquare':
			return {
				title: `${item.object.data?.key}: ${item.object.data?.name}` || '',
				description: `Atlas ${item.object.type}`,
				subheading: (
					<EventTypeMessage timestamp={item.event.timestamp} eventType={item.event.eventType} />
				),
				icon: (
					<img
						width={24}
						height={24}
						src={item.object.data?.iconData || ''}
						alt={`${item.object.product} ${item.object.type}`}
					></img>
				),
				onClick: () => {},
				navigationUrl: item.object.data?.url || '',
				meta: `Atlas ${item.object.type}`,
			};
		default:
			return {
				title: '',
				icon: <Fragment />,
				onClick: () => {
					return;
				},
			};
	}
};
